// test1154
(1154 && 0);
